//@flow
import React from 'react';
import Tooltip from 'rc-tooltip';

type Props = {
  total:?number|string,
  itemName?:string|React$Element<*>,
  className?:string,
  isNegative?:boolean,
  showIfNull?:boolean,
  itemDisclaimer?:string,
  itemClassName?:string,
  itemNameClassName?:string,
  itemTotalClassName?:string,
  prevTotal?:number|string,
  itemPrevTotalClassName?:string,
  infoTooltip?:string|React$Node,
};

export default function TotalItem(props:Props) {
  const showIfNull = props.showIfNull === undefined ? true : props.showIfNull;
  const itemNameClassName = props.itemNameClassName || 'columns small-9';
  const itemTotalClassName = props.itemTotalClassName || 'columns small-3 item-price';
  const itemPrevTotalClassName = props.itemPrevTotalClassName || 'columns small-3 item-price';
  const itemClassName = props.itemClassName || 'row';

  if (!props.total && !showIfNull) return null;

  const prettyTotal = _getPrettyTotal(props);
  return (
    <div className={props.className}>
      <div className={itemClassName}>
        <span className={itemNameClassName}>
          {props.itemName}
          {_getInfoTooltip(props)}
        </span>
        {props.prevTotal &&
          <span className={itemPrevTotalClassName}>
            {props.prevTotal}
          </span>
        }
        <span className={itemTotalClassName}>
          {prettyTotal}
        </span>
      </div>
      {_getDisclaimer(props)}
    </div>
  );
}

function _getDisclaimer(props:Props) {
  if (!props.itemDisclaimer) return null;
  return (<div className="item-disclaimer">{props.itemDisclaimer}</div>);
}

function _getPrettyTotal(props:Props) {
  const total = props.total;
  if (!total) return '$0.00';
  if (typeof total === 'string') return total;

  if (props.isNegative) {
    return `-$${Math.abs(total).toFixed(2)}`;
  }

  return `$${total.toFixed(2)}`;
}

function _getInfoTooltip(props:Props) {
  if (!props.infoTooltip) return null;
  const content = (
    <div className="info-tooltip-content">{props.infoTooltip}</div>
  );

  return (
    <Tooltip
      prefixCls="nb-tooltip"
      placement="bottom"
      overlay={content}
      trigger={['hover', 'click']}
    >
      <span className="info-tooltip"></span>
    </Tooltip>
  );
}
